/* eslint-disable promise/param-names */
import axios from '@/http-common'

import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS } from '../actions/auth'
import { SIGNUP_REQUEST, SIGNUP_ERROR, SIGNUP_SUCCESS } from '../actions/auth'
import { SIGNIN_REQUEST, SIGNIN_ERROR, SIGNIN_SUCCESS } from '../actions/auth'
import { AUTH_LOGOUT } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'

const state = { 
  status: '', 
  token: localStorage.getItem('user-token') || '', 
  signupEmail: ''
}

const getters = {
  isAuthenticated: state => state.token != '',
  authStatus: state => state.status,
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios.post('/login', { email: payload.email, password: payload.password })
      .then(response => {
        localStorage.setItem('user-token', response.data.TOKEN)
        
        if (payload.guardarDatosAcceso) {
          localStorage.setItem('user-email', payload.email)
          localStorage.setItem('user-password', payload.password)  
          localStorage.setItem('user-persist', 'SI')
        }
        else {
          localStorage.removeItem('user-email')
          localStorage.removeItem('user-password')
          localStorage.setItem('user-persist', 'NO')
        }

        axios.defaults.headers.common['token'] = response.data.TOKEN

        commit(AUTH_SUCCESS, response.data)

        dispatch(USER_REQUEST)

        resolve(response)
      })
      .catch(error => {
        commit(AUTH_ERROR, error)

        localStorage.removeItem('user-token')
        
        reject(error.response.data.message)
      })     
    })
  },

  [SIGNUP_REQUEST]: ({commit}, payload) => {
    return new Promise((resolve, reject) => {
      commit(SIGNUP_REQUEST)

      axios.post('/login/signup', payload)
      .then(response => {
        commit(SIGNUP_SUCCESS, response.data)

        resolve(response)
      })
      .catch(error => {
        commit(SIGNUP_ERROR, error)
      
        reject(error.response.data.message)
      })     
    })
  },

  [SIGNIN_REQUEST]: ({commit}, payload) => {
    return new Promise((resolve, reject) => {
      commit(SIGNIN_REQUEST)

      axios.get('/login/signin/' + payload.token)
      .then(response => {
        commit(SIGNIN_SUCCESS)

        resolve(response.data)
      })
      .catch(error => {
        commit(SIGNIN_ERROR, error)
        
        reject(error.response.data.message)
      })     
    })
  },

  [AUTH_LOGOUT]: ({commit}) => {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)

      localStorage.removeItem('user-token')

      delete axios.defaults.headers.common['token']

      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.TOKEN
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'auth error'
  },
  [SIGNUP_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [SIGNUP_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.signupEmail = resp.EMAIL
  },
  [SIGNUP_ERROR]: (state) => {
    state.status = 'signup error'
  },
  [SIGNIN_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [SIGNIN_SUCCESS]: (state) => {
    state.status = 'success'
  },
  [SIGNIN_ERROR]: (state) => {
    state.status = 'signin error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
